import { render, staticRenderFns } from "./CCMAllergyEdit.vue?vue&type=template&id=6452ef08"
import script from "./CCMAllergyEdit.vue?vue&type=script&lang=js"
export * from "./CCMAllergyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports